import sendToLurker from '../../Lurker';
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const sendClickEvent = (objectDetail, position = 'main_menu', data) => {
    var _a;
    sendToLurker({
        eventType: 'click',
        objectDetail,
        objectName: 'navigation_bar',
        data: Object.assign({ position, page_name: (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a[0].page.pageType }, data),
    });
};
